import React from 'react';

import { defineMessages, useIntl } from 'react-intl-next';

import { Box, Stack } from '@atlaskit/primitives/compiled';
import { type RelatedEvents } from '@atlassian/audit-logs-common';

import { DetailsSection } from '../../../common/utils/components/details-section';
import { MAX_DISPLAYED_RELATED_EVENTS } from '../../../common/utils/constants';

import { RelatedActivitiesTable } from './related-activities-table';
import { TableFooter } from './table-footer';
import { TableHeader } from './table-header';

const messages = defineMessages({
	relatedActivities: {
		id: 'organization.audit.log.side-panel.tab-panels.related-activities.related-activities-section.title',
		defaultMessage: 'Related activities',
		description: 'Title for the related activities section in audit log related activities panel',
	},
});
interface OwnProps {
	relatedEvents: RelatedEvents;
}

export const RelatedActivitiesTabPanel = ({ relatedEvents }: OwnProps): React.JSX.Element => {
	const { formatMessage } = useIntl();
	const displayedEvents = relatedEvents.relatedEvents.slice(0, MAX_DISPLAYED_RELATED_EVENTS);
	const displayedEventsCount = displayedEvents.length;

	if (displayedEventsCount === 0) {
		return <Box></Box>;
	}

	return (
		<Stack>
			<Stack space="space.300">
				<TableHeader correlationId={relatedEvents.correlationId} />
				<DetailsSection title={formatMessage(messages.relatedActivities)}>
					<RelatedActivitiesTable relatedEvents={displayedEvents} />
				</DetailsSection>
			</Stack>
			<TableFooter
				displayedEventsCount={displayedEventsCount}
				totalEventsCount={relatedEvents.totalEventsCount}
				hasMoreEvents={relatedEvents.hasMoreEvents}
				relatedEventsLink={relatedEvents.relatedEventsLink ?? ''}
			/>
		</Stack>
	);
};
